(function () {
  const STORAGE_KEY = "recently_viewed_products";
  const MAX_STORED = 20;
  const DEFAULT_LIMIT = 8;

  function getStoredHandles() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function recordViewedProduct() {
    const recorder = document.querySelector("[data-recently-viewed-record]");
    if (!recorder) return;

    const handle = recorder.getAttribute("data-recently-viewed-record");
    if (!handle) return;

    let handles = getStoredHandles().filter(
      (storedHandle) => storedHandle !== handle,
    );
    handles.unshift(handle);
    handles = handles.slice(0, MAX_STORED);

    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    } catch (e) {
      // localStorage unavailable (private browsing, quota, etc) - fail silently.
    }
  }

  function renderRecentlyViewed() {
    const box = document.querySelector("[data-recently-viewed-products]");
    if (!box) return;

    const section = box.closest(".section-featured-collection");
    const wrapper = box.querySelector(".swiper-wrapper");
    if (!section || !wrapper) return;

    const recorder = document.querySelector("[data-recently-viewed-record]");
    const currentHandle = recorder
      ? recorder.getAttribute("data-recently-viewed-record")
      : null;
    const limit = parseInt(box.getAttribute("data-limit"), 10) || DEFAULT_LIMIT;
    const imageFit = box.getAttribute("data-image-fit") || "cover";

    const handles = getStoredHandles()
      .filter((handle) => handle !== currentHandle)
      .slice(0, limit);

    if (handles.length === 0) {
      section.style.display = "none";
      return;
    }

    const fetches = handles.map((handle) =>
      fetch(`/products/${handle}?view=recently-viewed-card`)
        .then((response) => (response.ok ? response.text() : null))
        .catch(() => null),
    );

    Promise.all(fetches).then((results) => {
      const fragment = document.createDocumentFragment();
      let cardCount = 0;

      results.forEach((html) => {
        if (!html) return;
        const doc = new DOMParser().parseFromString(html, "text/html");
        const card = doc.querySelector(".featured_collection__cards");
        if (card) {
          fragment.appendChild(card);
          cardCount += 1;
        }
      });

      wrapper
        .querySelectorAll(".is-recently-viewed-placeholder")
        .forEach((placeholder) => placeholder.remove());

      if (cardCount === 0) {
        section.style.display = "none";
        return;
      }

      fragment.querySelectorAll(".media--first, .media--second").forEach((img) => {
        img.style.objectFit = imageFit;
      });

      wrapper.appendChild(fragment);

      // Destroy and let featured-collection.js fully re-init the Swiper against the
      // final slide count, rather than calling .update() - this is what makes the
      // watchOverflow arrow/pagination auto-hide behave correctly.
      const $box = window.jQuery ? window.jQuery(box) : null;
      const swiperInstance = $box ? $box.data("swiperInstance") : null;
      if (swiperInstance) {
        swiperInstance.destroy(true, true);
        $box.removeData("swiperInstance");
      }

      // Rebind other card-level listeners (color swatches, hover animations, etc)
      // that only attach on DOMContentLoaded / shopify:section:load, and re-init Swiper.
      document.dispatchEvent(new Event("shopify:section:load"));
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    recordViewedProduct();
    renderRecentlyViewed();
  });
})();
